<ng-container>
  <cf-button class="w-100" size="lg" [color]="color" (click)="authWithGoogle()">
    <cf-icon className="d-flex" icon="google" class="ms-0 bg-white rounded-1"></cf-icon>
    {{ buttonName || ("auth.sign_up_google" | translate) }}
  </cf-button>
</ng-container>
